module.exports = __webpack_public_path__ + "img/about-us-image.6e6ffbda.svg";